import * as React from 'react';
import { ModuleProps } from 'src/utils/module-util';
import { DoubleImageProps } from 'src/components/common/module-util';
import { DoubleImageComponent } from 'src/components/common/modules/v1/double-image/code-split/double-image-component';

// Css Style Import
import(/* webpackChunkName: "v1-double-image-styles" */ 'src/components/common/modules/v1/double-image/styles/double-image.css');

const DoubleImageModule = (props: ModuleProps) => {
  const { data } = props;
  let doubleImageArray = [];
  const doubleImage1: DoubleImageProps = {
    imgName: data?.image1?.[0]?.name,
    imgUrls: data?.image1?.[0]?.url,
    imgCaption: data?.image1Caption,
    imgCopyRight: data?.image1Copyright,
    imgDesc: data?.image1Description,
  };

  const doubleImage2: DoubleImageProps = {
    imgName: data?.image2?.[0]?.name,
    imgUrls: data?.image2?.[0]?.url,
    imgCaption: data?.image2Caption,
    imgCopyRight: data?.image2Copyright,
    imgDesc: data?.image2Description,
  };

  doubleImageArray = [{ ...doubleImage1 }, { ...doubleImage2 }];

  return <DoubleImageComponent doubleImages={doubleImageArray} {...props} />;
};

export { DoubleImageModule };
